
import { useState } from 'react';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function Destinations() {
  const [showAllDestinations, setShowAllDestinations] = useState(false);

  const destinations = [
    {
      name: 'Kerala Backwaters',
      price: 'From ₹25,999',
      image: 'https://readdy.ai/api/search-image?query=serene%20Kerala%20backwaters%20with%20traditional%20houseboat%20floating%20on%20calm%20waters%2C%20lush%20green%20coconut%20palms%20lining%20the%20banks%2C%20beautiful%20reflection%20in%20water%2C%20golden%20sunset%20lighting%2C%20peaceful%20Indian%20travel%20destination%2C%20professional%20tourism%20photography%2C%20tropical%20paradise%20in%20Gods%20own%20country&width=500&height=600&seq=dest-kerala&orientation=portrait',
      description: 'God\'s Own Country',
      rating: 4.9,
      reviews: 2847,
      searchQuery: 'Kerala backwaters tourism guide houseboat booking',
      category: 'domestic'
    },
    {
      name: 'Rajasthan Royal Tour',
      price: 'From ₹35,999',
      image: 'https://readdy.ai/api/search-image?query=magnificent%20Rajasthan%20palace%20with%20intricate%20Mughal%20architecture%2C%20golden%20sandstone%20walls%2C%20beautiful%20arches%20and%20domes%2C%20camel%20caravan%20in%20foreground%2C%20desert%20landscape%2C%20royal%20Indian%20heritage%20site%2C%20professional%20travel%20photography%2C%20warm%20golden%20hour%20lighting&width=500&height=600&seq=dest-rajasthan&orientation=portrait',
      description: 'Land of Kings',
      rating: 4.8,
      reviews: 1923,
      searchQuery: 'Rajasthan royal palaces tourism Jaipur Udaipur travel guide',
      category: 'domestic'
    },
    {
      name: 'Goa Beaches',
      price: 'From ₹15,999',
      image: 'https://readdy.ai/api/search-image?query=pristine%20Goa%20beach%20with%20golden%20sand%20and%20clear%20blue%20Arabian%20Sea%2C%20swaying%20coconut%20palm%20trees%2C%20colorful%20beach%20shacks%2C%20beautiful%20sunset%20colors%2C%20tropical%20Indian%20coastal%20paradise%2C%20professional%20beach%20photography%2C%20relaxing%20vacation%20destination&width=500&height=600&seq=dest-goa&orientation=portrait',
      description: 'Tropical Beach Paradise',
      rating: 4.9,
      reviews: 3156,
      searchQuery: 'Goa beaches tourism travel guide best beaches to visit',
      category: 'domestic'
    },
    {
      name: 'Himachal Hill Stations',
      price: 'From ₹22,999',
      image: 'https://readdy.ai/api/search-image?query=majestic%20Himachal%20Pradesh%20mountains%20with%20snow-capped%20peaks%2C%20lush%20green%20valleys%2C%20traditional%20wooden%20houses%2C%20pine%20forests%2C%20crystal%20clear%20mountain%20streams%2C%20beautiful%20Himalayan%20landscape%2C%20professional%20mountain%20photography%2C%20serene%20hill%20station%20destination&width=500&height=600&seq=dest-himachal&orientation=portrait',
      description: 'Mountain Adventures',
      rating: 4.7,
      reviews: 4231,
      searchQuery: 'Himachal Pradesh hill stations Manali Shimla tourism guide',
      category: 'domestic'
    },
    {
      name: 'Golden Triangle',
      price: 'From ₹28,999',
      image: 'https://readdy.ai/api/search-image?query=iconic%20Taj%20Mahal%20at%20sunrise%20with%20beautiful%20marble%20architecture%2C%20intricate%20Islamic%20design%2C%20reflection%20pool%20in%20foreground%2C%20clear%20blue%20sky%2C%20symbol%20of%20eternal%20love%2C%20UNESCO%20World%20Heritage%20site%2C%20professional%20architectural%20photography%2C%20golden%20morning%20light&width=500&height=600&seq=dest-taj&orientation=portrait',
      description: 'Delhi-Agra-Jaipur Circuit',
      rating: 4.8,
      reviews: 2674,
      searchQuery: 'Golden Triangle tour Delhi Agra Jaipur tourism guide',
      category: 'domestic'
    },
    {
      name: 'Tamil Nadu Temples',
      price: 'From ₹19,999',
      image: 'https://readdy.ai/api/search-image?query=magnificent%20Tamil%20Nadu%20temple%20with%20tall%20gopuram%20tower%2C%20intricate%20Dravidian%20architecture%2C%20colorful%20sculptures%20and%20carvings%2C%20devotees%20in%20traditional%20attire%2C%20spiritual%20atmosphere%2C%20ancient%20South%20Indian%20heritage%2C%20professional%20cultural%20photography&width=500&height=600&seq=dest-tamil&orientation=portrait',
      description: 'South Indian Heritage',
      rating: 4.9,
      reviews: 1845,
      searchQuery: 'Tamil Nadu temple tourism Madurai Thanjavur travel guide',
      category: 'domestic'
    }
  ];

  const additionalDestinations = [
    // More Indian Destinations
    {
      name: 'Kashmir Valley',
      price: 'From ₹32,999',
      image: 'https://readdy.ai/api/search-image?query=breathtaking%20Kashmir%20valley%20with%20snow-capped%20mountains%2C%20pristine%20lakes%2C%20colorful%20houseboats%20on%20Dal%20Lake%2C%20Mughal%20gardens%2C%20paradise%20on%20earth%2C%20beautiful%20Himalayan%20landscape%2C%20professional%20mountain%20photography%2C%20serene%20valley%20destination&width=500&height=600&seq=dest-kashmir&orientation=portrait',
      description: 'Paradise on Earth',
      rating: 4.8,
      reviews: 1567,
      searchQuery: 'Kashmir valley tourism Srinagar Dal Lake travel guide',
      category: 'domestic'
    },
    {
      name: 'Uttarakhand Pilgrimage',
      price: 'From ₹24,999',
      image: 'https://readdy.ai/api/search-image?query=sacred%20Uttarakhand%20pilgrimage%20sites%20with%20ancient%20temples%2C%20holy%20Ganges%20river%2C%20spiritual%20devotees%2C%20mountain%20backdrop%2C%20religious%20ceremonies%2C%20peaceful%20atmosphere%2C%20divine%20Indian%20heritage%2C%20professional%20spiritual%20photography&width=500&height=600&seq=dest-uttarakhand&orientation=portrait',
      description: 'Spiritual Journey',
      rating: 4.7,
      reviews: 2134,
      searchQuery: 'Uttarakhand pilgrimage Haridwar Rishikesh Char Dham tourism',
      category: 'domestic'
    },
    {
      name: 'Andaman Islands',
      price: 'From ₹45,999',
      image: 'https://readdy.ai/api/search-image?query=pristine%20Andaman%20islands%20with%20crystal%20clear%20turquoise%20waters%2C%20white%20sandy%20beaches%2C%20coral%20reefs%2C%20tropical%20paradise%2C%20water%20sports%20activities%2C%20untouched%20natural%20beauty%2C%20professional%20island%20photography%2C%20exotic%20vacation%20destination&width=500&height=600&seq=dest-andaman&orientation=portrait',
      description: 'Tropical Island Paradise',
      rating: 4.9,
      reviews: 1892,
      searchQuery: 'Andaman Nicobar islands tourism Havelock island travel guide',
      category: 'domestic'
    },
    {
      name: 'Northeast Circuit',
      price: 'From ₹38,999',
      image: 'https://readdy.ai/api/search-image?query=stunning%20Northeast%20India%20landscape%20with%20rolling%20hills%2C%20tea%20gardens%2C%20tribal%20culture%2C%20bamboo%20forests%2C%20traditional%20villages%2C%20diverse%20wildlife%2C%20untouched%20natural%20beauty%2C%20professional%20cultural%20photography%2C%20hidden%20gem%20destination&width=500&height=600&seq=dest-northeast&orientation=portrait',
      description: 'Hidden Gems of India',
      rating: 4.6,
      reviews: 987,
      searchQuery: 'Northeast India tourism Sikkim Meghalaya Assam travel guide',
      category: 'domestic'
    },
    // International - South Asian Countries
    {
      name: 'Nepal Adventure',
      price: 'From ₹52,999',
      image: 'https://readdy.ai/api/search-image?query=majestic%20Mount%20Everest%20and%20Himalayan%20peaks%20in%20Nepal%2C%20traditional%20Buddhist%20monasteries%2C%20prayer%20flags%20fluttering%20in%20mountain%20breeze%2C%20trekking%20trails%2C%20spiritual%20atmosphere%2C%20adventure%20tourism%20destination%2C%20professional%20mountain%20photography&width=500&height=600&seq=dest-nepal&orientation=portrait',
      description: 'Himalayan Kingdom',
      rating: 4.8,
      reviews: 1456,
      searchQuery: 'Nepal tourism Kathmandu Everest base camp trekking guide',
      category: 'international'
    },
    {
      name: 'Sri Lanka',
      price: 'From ₹48,999',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20Sri%20Lankan%20landscape%20with%20ancient%20Buddhist%20temples%2C%20tea%20plantations%20on%20rolling%20hills%2C%20pristine%20beaches%2C%20traditional%20stilt%20fishermen%2C%20colonial%20architecture%2C%20tropical%20paradise%2C%20professional%20travel%20photography&width=500&height=600&seq=dest-srilanka&orientation=portrait',
      description: 'Pearl of the Indian Ocean',
      rating: 4.7,
      reviews: 1234,
      searchQuery: 'Sri Lanka tourism Colombo Kandy Galle travel guide',
      category: 'international'
    },
    {
      name: 'Bhutan',
      price: 'From ₹65,999',
      image: 'https://readdy.ai/api/search-image?query=mystical%20Bhutan%20monastery%20perched%20on%20mountain%20cliff%2C%20traditional%20architecture%2C%20prayer%20wheels%2C%20colorful%20prayer%20flags%2C%20peaceful%20Buddhist%20monks%2C%20Himalayan%20backdrop%2C%20spiritual%20atmosphere%2C%20last%20Shangri-La%20destination%2C%20professional%20cultural%20photography&width=500&height=600&seq=dest-bhutan&orientation=portrait',
      description: 'Last Shangri-La',
      rating: 4.9,
      reviews: 876,
      searchQuery: 'Bhutan tourism Thimphu Paro Tigers Nest monastery travel guide',
      category: 'international'
    },
    {
      name: 'Maldives',
      price: 'From ₹85,999',
      image: 'https://readdy.ai/api/search-image?query=luxury%20Maldives%20resort%20with%20overwater%20bungalows%2C%20crystal%20clear%20turquoise%20lagoon%2C%20white%20sandy%20beaches%2C%20tropical%20paradise%2C%20romantic%20sunset%2C%20water%20villas%2C%20professional%20luxury%20resort%20photography%2C%20honeymoon%20destination&width=500&height=600&seq=dest-maldives&orientation=portrait',
      description: 'Tropical Paradise',
      rating: 4.9,
      reviews: 2156,
      searchQuery: 'Maldives tourism luxury resorts water villas travel guide',
      category: 'international'
    },
    // International - Southeast Asia
    {
      name: 'Thailand',
      price: 'From ₹42,999',
      image: 'https://readdy.ai/api/search-image?query=magnificent%20Thai%20temple%20with%20golden%20Buddha%20statue%2C%20ornate%20architecture%2C%20traditional%20Thai%20design%2C%20tropical%20setting%2C%20cultural%20heritage%2C%20bustling%20Bangkok%20cityscape%2C%20beautiful%20beaches%2C%20professional%20travel%20photography%2C%20exotic%20destination&width=500&height=600&seq=dest-thailand&orientation=portrait',
      description: 'Land of Smiles',
      rating: 4.8,
      reviews: 3267,
      searchQuery: 'Thailand tourism Bangkok Phuket Pattaya travel guide',
      category: 'international'
    },
    {
      name: 'Singapore',
      price: 'From ₹55,999',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20Singapore%20skyline%20with%20Marina%20Bay%20Sands%2C%20Gardens%20by%20the%20Bay%2C%20modern%20architecture%2C%20vibrant%20city%20lights%2C%20luxury%20shopping%20districts%2C%20multicultural%20atmosphere%2C%20professional%20urban%20photography%2C%20cosmopolitan%20destination&width=500&height=600&seq=dest-singapore&orientation=portrait',
      description: 'Garden City',
      rating: 4.8,
      reviews: 1987,
      searchQuery: 'Singapore tourism Marina Bay Sentosa island travel guide',
      category: 'international'
    },
    {
      name: 'Malaysia',
      price: 'From ₹38,999',
      image: 'https://readdy.ai/api/search-image?query=iconic%20Petronas%20Twin%20Towers%20in%20Kuala%20Lumpur%20Malaysia%2C%20modern%20skyscrapers%2C%20traditional%20Islamic%20architecture%2C%20tropical%20rainforest%2C%20beautiful%20beaches%2C%20multicultural%20heritage%2C%20professional%20urban%20photography%2C%20diverse%20destination&width=500&height=600&seq=dest-malaysia&orientation=portrait',
      description: 'Truly Asia',
      rating: 4.7,
      reviews: 1678,
      searchQuery: 'Malaysia tourism Kuala Lumpur Langkawi Penang travel guide',
      category: 'international'
    },
    {
      name: 'Indonesia',
      price: 'From ₹46,999',
      image: 'https://readdy.ai/api/search-image?query=stunning%20Bali%20Indonesia%20rice%20terraces%20with%20traditional%20temples%2C%20tropical%20beaches%2C%20volcanic%20mountains%2C%20Hindu%20culture%2C%20traditional%20dancers%2C%20lush%20green%20landscapes%2C%20professional%20cultural%20photography%2C%20exotic%20island%20paradise&width=500&height=600&seq=dest-indonesia&orientation=portrait',
      description: 'Emerald of the Equator',
      rating: 4.7,
      reviews: 1543,
      searchQuery: 'Indonesia tourism Bali Jakarta Yogyakarta travel guide',
      category: 'international'
    },
    // Middle East & Others
    {
      name: 'Dubai UAE',
      price: 'From ₹58,999',
      image: 'https://readdy.ai/api/search-image?query=magnificent%20Dubai%20skyline%20with%20Burj%20Khalifa%2C%20luxury%20hotels%2C%20golden%20desert%20dunes%2C%20modern%20architecture%2C%20shopping%20malls%2C%20traditional%20souks%2C%20futuristic%20cityscape%2C%20professional%20urban%20photography%2C%20luxury%20destination&width=500&height=600&seq=dest-dubai&orientation=portrait',
      description: 'City of Gold',
      rating: 4.8,
      reviews: 2834,
      searchQuery: 'Dubai UAE tourism Burj Khalifa desert safari travel guide',
      category: 'international'
    },
    {
      name: 'Japan',
      price: 'From ₹78,999',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20Japan%20cherry%20blossom%20season%20with%20traditional%20temple%2C%20Mount%20Fuji%20backdrop%2C%20pink%20sakura%20flowers%2C%20peaceful%20garden%2C%20traditional%20architecture%2C%20serene%20atmosphere%2C%20cultural%20heritage%2C%20professional%20spring%20photography%2C%20iconic%20destination&width=500&height=600&seq=dest-japan&orientation=portrait',
      description: 'Land of Rising Sun',
      rating: 4.9,
      reviews: 1765,
      searchQuery: 'Japan tourism Tokyo Kyoto cherry blossom travel guide',
      category: 'international'
    },
    {
      name: 'South Korea',
      price: 'From ₹65,999',
      image: 'https://readdy.ai/api/search-image?query=modern%20Seoul%20South%20Korea%20cityscape%20with%20traditional%20Gyeongbokgung%20palace%2C%20contemporary%20architecture%2C%20K-culture%20elements%2C%20beautiful%20autumn%20colors%2C%20traditional%20hanbok%20costumes%2C%20vibrant%20city%20life%2C%20professional%20urban%20photography&width=500&height=600&seq=dest-korea&orientation=portrait',
      description: 'K-Culture Hub',
      rating: 4.7,
      reviews: 1298,
      searchQuery: 'South Korea tourism Seoul Busan Jeju island travel guide',
      category: 'international'
    }
  ];

  const handleViewDetails = (destination: any) => {
    const googleSearchUrl = `https://www.google.com/search?q=${encodeURIComponent(destination.searchQuery)}`;
    window.open(googleSearchUrl, '_blank');
  };

  const handleViewAllDestinations = () => {
    setShowAllDestinations(!showAllDestinations);
  };

  const allDestinations = showAllDestinations ? [...destinations, ...additionalDestinations] : destinations;

  return (
    <section id="destinations" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {showAllDestinations ? 'All Travel Destinations' : 'Popular Indian Destinations'}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {showAllDestinations 
              ? 'Explore our complete collection of domestic and international destinations covering India, South Asia, Southeast Asia, and beyond.'
              : 'Discover India\'s incredible diversity with our expertly crafted tour packages covering heritage sites, hill stations, beaches, and cultural experiences.'
            }
          </p>
        </div>

        {showAllDestinations && (
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <div className="bg-blue-100 text-blue-800 px-6 py-3 rounded-full font-semibold">
              <i className="ri-flag-line mr-2"></i>
              Domestic Destinations
            </div>
            <div className="bg-green-100 text-green-800 px-6 py-3 rounded-full font-semibold">
              <i className="ri-earth-line mr-2"></i>
              International Destinations
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {allDestinations.map((destination, index) => (
            <Card key={index} hover className="overflow-hidden">
              <div className="relative h-64 overflow-hidden">
                <img
                  src={destination.image}
                  alt={destination.name}
                  className="w-full h-full object-cover object-top transition-transform duration-300 hover:scale-105"
                />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                  <span className="text-sm font-semibold text-gray-900">{destination.price}</span>
                </div>
                {showAllDestinations && (
                  <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-semibold ${
                    destination.category === 'domestic' 
                      ? 'bg-blue-100 text-blue-800' 
                      : 'bg-green-100 text-green-800'
                  }`}>
                    {destination.category === 'domestic' ? 'DOMESTIC' : 'INTERNATIONAL'}
                  </div>
                )}
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-bold text-gray-900">{destination.name}</h3>
                  <div className="flex items-center">
                    <i className="ri-star-fill text-yellow-400 mr-1"></i>
                    <span className="text-sm font-medium text-gray-700">{destination.rating}</span>
                  </div>
                </div>
                <p className="text-gray-600 mb-4">{destination.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">{destination.reviews.toLocaleString()} reviews</span>
                  <Button 
                    size="sm"
                    onClick={() => handleViewDetails(destination)}
                  >
                    <i className="ri-arrow-right-line ml-1"></i>
                    View Details
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button size="lg" onClick={handleViewAllDestinations}>
            <i className={`${showAllDestinations ? 'ri-arrow-up-line' : 'ri-map-line'} mr-2`}></i>
            {showAllDestinations ? 'Show Less Destinations' : 'View All Destinations'}
          </Button>
          {showAllDestinations && (
            <p className="text-gray-600 mt-4 text-lg">
              Showing all {allDestinations.length} destinations across India and international locations
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
